// extracted by mini-css-extract-plugin
module.exports = {"viewMoreButton":"jpFiCk1I"};